import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from '~constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { constructUrlWithParams } from '../helpers'

export type FilterField =
  'portCountry' | 'portName' | 'terminalName' | 'berthName'

export interface PortOption {
  portName: string
  portCode: string
}

export interface GetPortInfoFiltersParams {
  field: FilterField
  portCountry?: string[]
  portName?: string[]
  terminalName?: string[]
  berthName?: string[]
  enabled?: boolean
}

export interface PortInfoFiltersResponse {
  portCountry?: string[]
  portName?: PortOption[]
  terminalName?: string[]
  berthName?: string[]
}

export function useGetPortInfoFilters(params: GetPortInfoFiltersParams) {
  const fetchRequest = useFetch<PortInfoFiltersResponse>()
  const { enabled = true, ...queryParams } = params

  const url = constructUrlWithParams('/portinfo/filters', queryParams)

  return useQuery({
    queryKey: ['/portinfo/filters', queryParams],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    staleTime: tenMinutes,
    enabled,
  })
}
